module.exports = __webpack_public_path__ + "img/gb-sct.ade55ed4.svg";